// extracted by mini-css-extract-plugin
export default {"container":"eG-z","innerContainer":"fG-z","multipleLines":"gG-z","heading":"hG-z","content":"iG-z","linkColor":"jG-z"};